import { z } from "zod";
export const verifyIdentifier = z
  .string()
  .nonempty("Email ID is required")
  .refine((v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v), "Must be a valid email");

export const loginSchema = z.object({
  identifier: verifyIdentifier,
});
